module.exports = __webpack_public_path__ + "img/1482273518.6a648eb3.jpg";